import React from "react";
import RootRoutes from "./Routes/RootRoutes";
import useAuthCheck from "./hooks/useAuthCheck";
import Loading from "./components/Ui/Loading";

function App() {
  const authCheck = useAuthCheck();
  return <>{authCheck ? <RootRoutes /> : <Loading />}</>;
}

export default App;
